import { useState, useRef, useEffect } from "react";
import Layout from "../Common/Layout";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import ANNEXURE from "./ANNEXURE";
import LabourReportTable from "./LabourReportTable";

export default function BillingForm() {
  const [clients, setClients] = useState([]);
  const [isAddingClient, setIsAddingClient] = useState(false);

  const [hsnList, setHsnList] = useState([]);

  const [states, setStates] = useState([]);

  const [showAddHsn, setShowAddHsn] = useState(false);
  const [newHsn, setNewHsn] = useState("");
  const [activeHsnRow, setActiveHsnRow] = useState(null);
  const [showAddState, setShowAddState] = useState(false);
  const [newState, setNewState] = useState({ stateName: "", stateCode: "" });

  useEffect(() => {
    fetchHsn();
  }, []);

  const fetchHsn = async () => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await axios.get(
        "https://irc.zentelex.com/api/hsn/all",
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        }
      );

      setHsnList(res.data.data || []);
    } catch (error) {
      console.error("Error fetching HSN:", error);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);


const fetchClients = async () => {
  try {
    const token = sessionStorage.getItem("token");

    const res = await axios.get(
      "https://irc.zentelex.com/api/invoices/clients",	    
    //  "https://irc.zentelex.com/api/invoices/get-all",
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );

    const data = res.data.data || [];

    setClients(data);
  } catch (err) {
    console.error("Error fetching clients:", err);
  }
};



  useEffect(() => {
    fetchStates();
  }, []);

  const fetchStates = async () => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await axios.get(
        "https://irc.zentelex.com/api/states",
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        }
      );

      setStates(res.data);
    } catch (error) {
      console.error("Error fetching states", error);
    }
  };

  const [warehouses, setWarehouses] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchWarehousesByClient = async () => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await axios.get(
        `https://irc.zentelex.com/api/commodity-receipts/warehouses/${formData.clientName}`,
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        },
      );

      setWarehouses(res.data.data);
    } catch (error) {
      console.error("Error fetching warehouses:", error);
    }
  };

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // YYYY-MM-DD format
  };

  const [labourTotal, setLabourTotal] = useState(0); // 🔹 store labour total

  const [peakStock, setPeakStock] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const storedTotal = sessionStorage.getItem("labourTotal");

      if (storedTotal) {
        setLabourTotal(Number(storedTotal));
      }
    }, 300); // check every 300ms

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const storedPeakStock = JSON.parse(sessionStorage.getItem("peakStock"));

      if (storedPeakStock) {
        const value =
          typeof storedPeakStock === "number"
            ? storedPeakStock
            : storedPeakStock.value;

        setPeakStock(Number(value || 0));
      }
    }, 300);

    return () => clearInterval(interval);
  }, []);

  const [billType, setBillType] = useState("labour"); // default value

  const debounceRef = useRef(null);

  const getInitialFormState = () => ({
    invoiceId: "",

    invoiceType: "GST",
    invoiceNumber: "",
    invoiceDate: new Date().toISOString().split("T")[0], // ✅ today

    // E-Invoice Details
    irn: "",
    ackNo: "",
    ackDate: "",
    einvoiceQrData: "",

    invoiceState: "",
    invoiceStateCode: "",

    clientName: "",
    clientEmail: "",
    gstin: "",
    state: "",
    stateCode: "",
    contactNumber: "",
    panNo: "",
    clientAddress: "",

    receiverName: "",
    receiverGstin: "",
    receiverState: "",
    receiverStateCode: "",
    receiverContactNumber: "",
    receiverAddress: "",

    warehouseId: "",
    godownName: "",
    location: "",
    godownCode: "",

    items: [
      {
        service: "",
        hsn_code: "",
        quantity: "",
        rate: "",
        amount: "0.00",

        // Billing period
        billing_type: "MONTHLY",
        billing_start_date: "",
        billing_end_date: "",
        billing_days: "",
      },
    ],

    cgst: "",
    sgst: "",
    subtotal: "0.00",
    taxAmount: "0.00",
    grandTotal: "0.00",

    note: "",
  });

  const [formData, setFormData] = useState(getInitialFormState());
  const [sameAsClient, setSameAsClient] = useState(false);

  const [selectedWarehouses, setSelectedWarehouses] = useState([]);

 const [warehouseBillingMode, setWarehouseBillingMode] =
  useState("single");

  useEffect(() => {
    if (formData.clientName) {
      fetchWarehousesByClient();
    } else {
      setWarehouses([]);
    }
  }, [formData.clientName]);



  useEffect(() => {
    setFormData((prev) => {
      let items = [...prev.items];
      if (billType === "labour") {
        items[0] = {
          ...items[0],
          service: "Additional Warehousing Service Charge",
          quantity: 0, // ✅ Always 0
          rate: 0, // optional (cleaner)
          amount: labourTotal.toFixed(2),
        };
      }

      if (billType === "storage") {
        const qty = peakStock;
        const rate = parseFloat(items[0].rate) || 0;

        const billingType = items[0].billing_type || "MONTHLY";

        let billingDays = "";
        let amount = (qty * rate).toFixed(2);

        if (billingType === "DAILY") {
          const days = calculateBillingDays(
            items[0].billing_start_date,
            items[0].billing_end_date
          );

          billingDays = days || "";
          amount = (qty * rate * days).toFixed(2);
        }

        items[0] = {
          ...items[0],
          service: "storage",
          quantity: qty,
          rate: rate,
          amount: amount,
          billing_type: billingType,
          billing_days: billingDays,
        };
      }

      const cgst = parseFloat(prev.cgst) || 0;
      const sgst = parseFloat(prev.sgst) || 0;

      const subtotal = items.reduce(
        (sum, i) => sum + parseFloat(i.amount || 0),
        0,
      );

      const taxAmount = (subtotal * (cgst + sgst)) / 100;
      const grandTotal = subtotal + taxAmount;

      return {
        ...prev,
        items,
        subtotal: subtotal.toFixed(2),
        taxAmount: taxAmount.toFixed(2),
        grandTotal: grandTotal.toFixed(2),
      };
    });
  }, [billType, labourTotal, peakStock, formData.cgst, formData.sgst]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "clientName") {
      sessionStorage.setItem("clientName", value);
    }
  };
  const handleSameAsClient = (checked) => {
  setSameAsClient(checked);

  if (checked) {
    setFormData((prev) => ({
      ...prev,
      receiverName: prev.clientName,
      receiverGstin: prev.gstin,
      receiverState: prev.state,
      receiverStateCode: prev.stateCode,
      receiverContactNumber: prev.contactNumber,
      receiverAddress: prev.clientAddress,
    }));
  }
};

/*  const selectClient = (client) => {
    setFormData({
      ...formData,
      clientName: client.clientName,
      gstin: client.gstin,
      state: client.state,
      stateCode: client.stateCode,
      contactNumber: client.contactNumber,
      clientAddress: client.clientAddress,

      warehouseId: "",
      godownName: "",
      location: "",
    });
  };*/
   const selectClient = (client) => {
  setFormData((prev) => ({
    ...prev,
    clientName: client.clientName,
    gstin: client.gstin,
    state: client.state,
    stateCode: client.stateCode,
    contactNumber: client.contactNumber,
    clientAddress: client.clientAddress,

    warehouseId: "",
    godownName: "",
    location: "",
    godownCode: "",

    ...(sameAsClient
      ? {
          receiverName: client.clientName,
          receiverGstin: client.gstin,
          receiverState: client.state,
          receiverStateCode: client.stateCode,
          receiverContactNumber: client.contactNumber,
          receiverAddress: client.clientAddress,
        }
      : {}),
  }));

  setSelectedWarehouses([]);
};

  const calculateBillingDays = (startDate, endDate) => {
    if (!startDate || !endDate) return 0;

    const start = new Date(`${startDate}T00:00:00`);
    const end = new Date(`${endDate}T00:00:00`);

    if (
      Number.isNaN(start.getTime()) ||
      Number.isNaN(end.getTime()) ||
      end < start
    ) {
      return 0;
    }

    return Math.floor((end - start) / 86400000) + 1;
  };

  const recalculateTotals = (items, cgst, sgst, invoiceType) => {
    const subtotal = items.reduce(
      (sum, item) => sum + parseFloat(item.amount || 0),
      0,
    );

    let taxAmount = 0;

    if (invoiceType === "GST") {
      taxAmount = (subtotal * (cgst + sgst)) / 100;
    }

    return {
      subtotal: subtotal.toFixed(2),
      taxAmount: taxAmount.toFixed(2),
      grandTotal: (subtotal + taxAmount).toFixed(2),
    };
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...formData.items];
    updatedItems[index][field] = value;

    // Labour billing keeps its existing calculation.
    // Storage supports Monthly and Daily billing.
    if (billType !== "labour") {
      const item = updatedItems[index];

      const qty = parseFloat(item.quantity) || 0;
      const rate = parseFloat(item.rate) || 0;

      if (item.billing_type === "DAILY") {
        const days = calculateBillingDays(
          item.billing_start_date,
          item.billing_end_date
        );

        updatedItems[index].billing_days = days || "";

        updatedItems[index].amount = (
          qty * rate * days
        ).toFixed(2);
      } else {
        updatedItems[index].billing_days = "";

        updatedItems[index].amount = (
          qty * rate
        ).toFixed(2);
      }
    }

    const totals = recalculateTotals(
      updatedItems,
      parseFloat(formData.cgst) || 0,
      parseFloat(formData.sgst) || 0,
      formData.invoiceType,
    );

    setFormData((prev) => ({
      ...prev,
      items: updatedItems,
      ...totals,
    }));
  };

  const addRow = () => {
    setFormData((prev) => {
      let newItem;

      if (billType === "labour") {
        newItem = {
          service: "Additional Warehousing Service Charge",
          hsn_code: "",
          quantity: 0,
          rate: 0,
          amount: labourTotal.toFixed(2), // ✅ auto-fill labour amount
        };
      } else if (billType === "storage") {
        newItem = {
          service: "storage",
          hsn_code: "",
          quantity: peakStock,
          rate: "",
          amount: "0.00",
          billing_type: "MONTHLY",
          billing_start_date: "",
          billing_end_date: "",
          billing_days: "",
        };
      } else {
        newItem = {
          service: "",
          hsn_code: "",
          quantity: "",
          rate: "",
          amount: "0.00",
          billing_type: "MONTHLY",
          billing_start_date: "",
          billing_end_date: "",
          billing_days: "",
        };
      }

      return {
        ...prev,
        items: [...prev.items, newItem],
      };
    });
  };
  const removeRow = (index) => {
    const updatedItems = formData.items.filter((_, i) => i !== index);

    const totals = recalculateTotals(
      updatedItems,
      parseFloat(formData.cgst) || 0,
      parseFloat(formData.sgst) || 0,
      formData.invoiceType,
    );

    setFormData((prev) => ({
      ...prev,
      items: updatedItems,
      ...totals,
    }));
  };


  // ---------------------------------------------------
  // Invoice PDF Actions
  // ---------------------------------------------------
  const getInvoicePdfUrl = (invoiceId) => {
    return `https://irc.zentelex.com/api/invoices/${invoiceId}/pdf`;
  };

  const viewInvoicePdf = (invoiceId) => {
    if (!invoiceId) {
      alert("Invoice ID not found.");
      return;
    }

    window.open(
      getInvoicePdfUrl(invoiceId),
      "_blank",
      "noopener,noreferrer"
    );
  };

  const printInvoicePdf = (invoiceId) => {
    if (!invoiceId) {
      alert("Invoice ID not found.");
      return;
    }

    const printWindow = window.open(
      getInvoicePdfUrl(invoiceId),
      "_blank",
      "noopener,noreferrer"
    );

    if (!printWindow) {
      alert("Please allow pop-ups to print the invoice.");
      return;
    }
  };

  const downloadInvoicePdf = async (
    invoiceId,
    invoiceNumber = "invoice"
  ) => {
    if (!invoiceId) {
      alert("Invoice ID not found.");
      return;
    }

    try {
      const token = sessionStorage.getItem("token");

      const response = await axios.get(
        getInvoicePdfUrl(invoiceId),
        {
          responseType: "blob",
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        }
      );

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");

      link.href = url;
      link.download =
        `${invoiceNumber.replace(/[\/\\]/g, "_")}.pdf`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("PDF download failed:", error);
      alert("Failed to download invoice PDF.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = sessionStorage.getItem("token");

      const headers = {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      };

      // ---------------------------------------------------
      // Validate warehouse selection
      // ---------------------------------------------------
      if (
        !selectedWarehouses ||
        selectedWarehouses.length === 0
      ) {
        alert("Please select at least one warehouse.");
        return;
      }

      // ---------------------------------------------------
      // Store successfully created invoices
      // ---------------------------------------------------
      const savedInvoices = [];

      // ---------------------------------------------------
      // Build common invoice data
      // ---------------------------------------------------
      const commonInvoiceData = {
        ...formData,

        warehouseDetails: selectedWarehouses.map((w) => ({
          id: w.id,
          name: w.name,
          address: w.address,
        })),
      };

      // ---------------------------------------------------
      // CASE 1:
      // Single warehouse
      // ---------------------------------------------------
      if (selectedWarehouses.length === 1) {
        const warehouse = selectedWarehouses[0];

        const invoiceData = {
          ...commonInvoiceData,

          warehouseId: warehouse.id,
          godownName: warehouse.name,
          location: warehouse.address || "",

          warehouseDetails: [
            {
              id: warehouse.id,
              name: warehouse.name,
              address: warehouse.address,
            },
          ],
        };

        const res = await axios.post(
          "https://irc.zentelex.com/api/invoices",
          invoiceData,
          { headers }
        );

        console.log("Invoice Saved:", res.data);

        const savedInvoice = res.data?.data;

        if (savedInvoice?.id) {
          savedInvoices.push(savedInvoice);
        }
      }

      // ---------------------------------------------------
      // CASE 2:
      // Multiple warehouses - ONE invoice
      // ---------------------------------------------------
      else if (warehouseBillingMode === "single") {
        const firstWarehouse = selectedWarehouses[0];

        const invoiceData = {
          ...commonInvoiceData,

          warehouseId: firstWarehouse.id,
          godownName: firstWarehouse.name,
          location: firstWarehouse.address || "",

          warehouseDetails: selectedWarehouses.map((w) => ({
            id: w.id,
            name: w.name,
            address: w.address,
          })),
        };

        const res = await axios.post(
          "https://irc.zentelex.com/api/invoices",
          invoiceData,
          { headers }
        );

        console.log(
          "Multi-Warehouse Invoice Saved:",
          res.data
        );

        const savedInvoice = res.data?.data;

        if (savedInvoice?.id) {
          savedInvoices.push(savedInvoice);
        }
      }

      // ---------------------------------------------------
      // CASE 3:
      // Multiple warehouses - SEPARATE invoices
      // ---------------------------------------------------
      else if (warehouseBillingMode === "separate") {
        for (const warehouse of selectedWarehouses) {
          const invoiceData = {
            ...formData,

            warehouseId: warehouse.id,
            godownName: warehouse.name,
            location: warehouse.address || "",

            warehouseDetails: [
              {
                id: warehouse.id,
                name: warehouse.name,
                address: warehouse.address,
              },
            ],
          };

          const res = await axios.post(
            "https://irc.zentelex.com/api/invoices",
            invoiceData,
            { headers }
          );

          console.log(
            "Separate Invoice Saved:",
            res.data
          );

          const savedInvoice = res.data?.data;

          if (savedInvoice?.id) {
            savedInvoices.push(savedInvoice);
          }
        }
      }

      // ---------------------------------------------------
      // Verify invoice creation
      // ---------------------------------------------------
      if (savedInvoices.length === 0) {
        throw new Error(
          "Invoice was saved but the server did not return an invoice ID."
        );
      }

      console.log(
        "All Saved Invoices:",
        savedInvoices
      );

      // ---------------------------------------------------
      // PDF actions
      // ---------------------------------------------------
      if (savedInvoices.length === 1) {
        const invoice = savedInvoices[0];

        const invoiceNumber =
          invoice.invoiceNumber || "Invoice";

        const pdfUrl = getInvoicePdfUrl(invoice.id);

        const action = window.prompt(
          `Invoice ${invoiceNumber} saved successfully ✅\n\n` +
          `Enter:\n` +
          `1 = View PDF\n` +
          `2 = Download PDF\n` +
          `3 = Print PDF\n` +
          `0 = Continue without opening PDF`,
          "1"
        );

        if (action === "1") {
          viewInvoicePdf(invoice.id);
        }

        if (action === "2") {
          await downloadInvoicePdf(
            invoice.id,
            invoiceNumber
          );
        }

        if (action === "3") {
          printInvoicePdf(invoice.id);
        }
      } else {
        alert(
          `${savedInvoices.length} invoices saved successfully ✅\n\n` +
          `PDFs can be opened individually from the invoice list.`
        );
      }

      // ---------------------------------------------------
      // RESET FORM
      // ---------------------------------------------------
      setFormData(getInitialFormState());

      setWarehouses([]);
      setSelectedWarehouses([]);
      setWarehouseBillingMode("single");
      setSameAsClient(false);
      setBillType("labour");

      sessionStorage.removeItem("clientName");

    } catch (error) {
      console.error("Save failed:", error);

      console.error(
        "Server response:",
        error.response?.data
      );

      alert(
        error.response?.data?.message ||
        error.message ||
        "Failed to save invoice ❌"
      );
    }
  };

  const numberToWords = (num) => {
    if (!num) return "";

    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];

    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const convert = (n) => {
      if (n < 20) return a[n];
      if (n < 100)
        return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
      if (n < 1000)
        return (
          a[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 ? " " + convert(n % 100) : "")
        );
      if (n < 100000)
        return (
          convert(Math.floor(n / 1000)) +
          " Thousand" +
          (n % 1000 ? " " + convert(n % 1000) : "")
        );
      if (n < 10000000)
        return (
          convert(Math.floor(n / 100000)) +
          " Lakh" +
          (n % 100000 ? " " + convert(n % 100000) : "")
        );
      return (
        convert(Math.floor(n / 10000000)) +
        " Crore" +
        (n % 10000000 ? " " + convert(n % 10000000) : "")
      );
    };

    return convert(Math.floor(num)) + " Only";
  };

  return (
    <Layout>
      <div className="container my-4">
        <div className="col-md-4">
          <label className="form-label text-white">Bill Type</label>
          <select
            className="form-select"
            value={billType}
            onChange={(e) => setBillType(e.target.value)}
          >
            <option value="labour">
              Additional Warehousing Service Charge
            </option>
            <option value="storage">Storage</option>
          </select>
        </div>

        <div className="card shadow-sm border-0">
          <form
            className="card-body rounded-4 p-4"
            style={{ backgroundColor: "#3075A6" }}
            onSubmit={handleSubmit}
          >
            <h4 className="fw-bold mb-4 text-center text-white">
              Billing / Invoice Form
            </h4>

            {/* Invoice Details */}
            <h6 className="fw-semibold mb-3 text-white">Invoice Details</h6>
            <div className="row g-3">
              {/* Invoice Type */}
              <div className="col-md-3">
                <label className="form-label text-white">Invoice Type</label>
                <select
                  className="form-select"
                  name="invoiceType"
                  value={formData.invoiceType}
                  onChange={handleChange}
                >
                  <option value="GST">GST</option>
                  <option value="NON_GST">Non-GST</option>
                </select>
              </div>

              {/* Invoice Date */}
              <div className="col-md-3">
                <label className="form-label text-white">Invoice Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="invoiceDate"
                  value={formData.invoiceDate}
                  onChange={handleChange}
                />
              </div>

              {/* State */}
              <div className="col-md-3">
                <label className="form-label text-white">State</label>

                <select
                  className="form-control"
                  value={formData.invoiceState}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value === "ADD_NEW") {
                      setShowAddState(true);
                      return;
                    }

                    const selected = states.find((s) => s.stateName === value);

                    setFormData({
                      ...formData,
                      invoiceState: selected?.stateName || "",
                      invoiceStateCode: selected?.stateCode || "",
                    });
                  }}
                >
                  <option value="">Select State</option>

                  {states.map((s) => (
                    <option key={s.id} value={s.stateName}>
                      {s.stateName}
                    </option>
                  ))}

                  <option value="ADD_NEW">+ Add New State</option>
                </select>
              </div>

              {/* State Code */}
              <div className="col-md-3">
                <label className="form-label text-white">State Code</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.invoiceStateCode}
                  readOnly
                />
              </div>

              {/* Add New State Inline */}
              {showAddState && (
                <div className="col-md-6 mt-2">
                  <div className="p-2 border rounded bg-light">
                    <div className="row">
                      <div className="col-md-5">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="State Name"
                          value={newState.stateName}
                          onChange={(e) =>
                            setNewState({
                              ...newState,
                              stateName: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className="col-md-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="State Code"
                          value={newState.stateCode}
                          onChange={(e) =>
                            setNewState({
                              ...newState,
                              stateCode: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className="col-md-4 d-flex gap-2">
                        <button
                          type="button" // ✅ ADD THIS
                          className="btn btn-success btn-sm"
                          onClick={async () => {
                            try {
                             const token = sessionStorage.getItem("token");

                             const res = await axios.post(
                             "https://irc.zentelex.com/api/states",
                                newState,
                                 {
                                 headers: {
                                 Authorization: token ? `Bearer ${token}` : "",
                                  },
                                 }
                                );
                              setStates([...states, res.data]);

                              setFormData({
                                ...formData,
                                invoiceState: res.data.stateName,
                                invoiceStateCode: res.data.stateCode,
                              });

                              setNewState({ stateName: "", stateCode: "" });
                              setShowAddState(false);
                            } catch (err) {
                              alert(
                                err.response?.data?.message ||
                                  "Error adding state",
                              );
                            }
                          }}
                        >
                          Add
                        </button>

                        <button
                          type="button" // ✅ ADD THIS
                          className="btn btn-danger btn-sm"
                          onClick={() => setShowAddState(false)}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <hr className="my-4" />

            {/* Client Details */}
            <h6 className="fw-semibold mb-3 text-white">Client Details</h6>
            <div className="row g-3">
              <div className="col-md-4">
                <div style={{ position: "relative" }}>
                  {!isAddingClient ? (
                    <select
                      className="form-select"
                      value={formData.invoiceId}
                      onChange={(e) => {
                        const value = e.target.value;

                        // 👇 If user selects add new
                        if (value === "add_new") {
                          setIsAddingClient(true);
                          setFormData((prev) => ({
                            ...prev,
                            invoiceId: "",
                            clientName: "",
                            clientEmail: "",
                            gstin: "",
                            state: "",
                            stateCode: "",
                            contactNumber: "",
                            panNo: "",
                            clientAddress: "",
                          }));
                          return;
                        }
                       
     const selectedClient = clients.find(
     (c) => String(c.id) === String(value),
     );

    if (!selectedClient) return;

    setFormData((prev) => ({
      ...prev,

      invoiceId: selectedClient.id,

      clientName: selectedClient.client_name || "",
      gstin: selectedClient.gst_no || "",
      panNo: selectedClient.pan_no || "",

      clientEmail: "",
      contactNumber: "",
      clientAddress: "",
      state: "",
      stateCode: "",
    }));
                      /*  const selectedInvoice = clients.find(
                          (c) => String(c.id) === String(value),
                        );

                        if (!selectedInvoice) return;

                        setFormData((prev) => ({
                          ...prev,
                          invoiceId: selectedInvoice.id,
                          clientName: selectedInvoice.clientName,
                          clientEmail: selectedInvoice.clientEmail || "",
                          gstin: selectedInvoice.gstin,
                          state: selectedInvoice.state,
                          stateCode: selectedInvoice.stateCode,
                          contactNumber: selectedInvoice.contactNumber,
                          clientAddress: selectedInvoice.clientAddress,
                        }));*/
                      }}
                    >
                      <option value="">Select Client</option>

                      {clients.map((client) => (
                        <option key={client.id} value={client.id}>
                          {client.client_name}
                        </option>
                      ))}

                      {/* 👇 Add new option */}
                      <option value="add_new">➕ Add New Client</option>
                    </select>
                  ) : (
                    <div className="border rounded p-3 bg-light">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <p className="text-muted mb-0">Add New Client</p>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => setIsAddingClient(false)}
                        >
                          Cancel
                        </button>
                      </div>

                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Client Name"
                        value={formData.clientName}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            clientName: e.target.value,
                          }))
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email Address"
                  name="clientEmail"
                  value={formData.clientEmail}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="GSTIN"
                  name="gstin"
                  value={formData.gstin}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="State"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="State Code"
                  name="stateCode"
                  value={formData.stateCode}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="Contact Number"
                  name="contactNumber"
                  type="text"
                  maxLength={10}
                  value={formData.contactNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, ""); // Only digits
                    setFormData({
                      ...formData,
                      contactNumber: value.slice(0, 10), // Max 10 digits
                    });
                  }}
                />
              </div>

              {/* PAN No. - Optional */}
              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="PAN No."
                  name="panNo"
                  type="text"
                  maxLength={10}
                  value={formData.panNo}
                  onChange={(e) => {
                    const value = e.target.value
                      .toUpperCase()
                      .replace(/[^A-Z0-9]/g, "");

                    setFormData({
                      ...formData,
                      panNo: value.slice(0, 10),
                    });
                  }}
                />
              </div>

              <div className="col-md-8">
                <textarea
                  className="form-control"
                  name="clientAddress"
                  rows="2"
                  placeholder="FIRST FLOOR, 19A SOUTH RAJA STREET, TUTICORIN, 628001"
                  value={formData.clientAddress}
                  onChange={handleChange}
                />
              </div>

              {/* E-Invoice Details */}
              <div className="col-md-4">
                <label className="form-label text-white">
                  IRN
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="irn"
                  value={formData.irn}
                  onChange={handleChange}
                  placeholder="Enter IRN"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label text-white">
                  Ack No.
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="ackNo"
                  value={formData.ackNo}
                  onChange={handleChange}
                  placeholder="Enter Ack No."
                />
              </div>

              <div className="col-md-4">
                <label className="form-label text-white">
                  Ack Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="ackDate"
                  value={formData.ackDate}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-12">
                <label className="form-label text-white">
                  E-Invoice QR Data
                </label>
                <textarea
                  className="form-control"
                  name="einvoiceQrData"
                  value={formData.einvoiceQrData}
                  onChange={handleChange}
                  placeholder="Paste signed e-invoice QR data"
                  rows={2}
                />
              </div>

            </div>

            <hr className="my-4" />

            <h6 className="fw-semibold mb-3 text-white">Receiver Details</h6>
             <div className="form-check mb-3">
              <input
               className="form-check-input"
               type="checkbox"
                id="sameAsClient"
                 checked={sameAsClient}
                 onChange={(e) => handleSameAsClient(e.target.checked)}
                  />

                 <label
                className="form-check-label text-white"
                htmlFor="sameAsClient"
                 >
                Same as Client
                </label>
             </div>
            <div className="row g-3">
              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="Receiver Name"
                  name="receiverName"
                  value={formData.receiverName}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="GSTIN"
                  name="receiverGstin"
                  value={formData.receiverGstin}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="State"
                  name="receiverState"
                  value={formData.receiverState}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="State Code"
                  name="receiverStateCode"
                  value={formData.receiverStateCode}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="Contact Number"
                  name="receiverContactNumber"
                  type="text"
                  maxLength={10}
                  value={formData.receiverContactNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, ""); // Allow digits only
                    setFormData({
                      ...formData,
                      receiverContactNumber: value.slice(0, 10), // Max 10 digits
                    });
                  }}
                />
              </div>

              <div className="col-md-8">
                <textarea
                  className="form-control"
                  name="receiverAddress"
                  rows="2"
                  placeholder="FIRST FLOOR, 19A SOUTH RAJA STREET, TUTICORIN, 628001"
                  value={formData.receiverAddress}
                  onChange={handleChange}
                />
              </div>
            </div>

            <hr className="my-4" />

            {/* Warehouse Details */}
            <h6 className="fw-semibold mb-3 text-white">Warehouse Details</h6>

            <div className="row g-3">

              {/* Warehouse Billing Mode */}
              <div className="col-md-5">
                <label className="form-label text-white">
                  Warehouse Billing Mode
                </label>

                <select
                  className="form-select"
                  value={warehouseBillingMode}
                  onChange={(e) =>
                    setWarehouseBillingMode(e.target.value)
                  }
                >
                  <option value="single">
                    Single Invoice – Multiple Warehouses
                  </option>
                  <option value="separate">
                    Separate Invoice – Each Warehouse
                  </option>
                </select>
              </div>

              {/* Multiple Warehouse Selection */}
              <div className="col-md-7">
                <label className="form-label text-white">
                  Select Warehouse(s)
                </label>

                <select
                  className="form-select"
                  multiple
                  size={Math.min(Math.max(warehouses.length, 3), 6)}
                  value={selectedWarehouses.map((w) => w.id)}
                  onChange={(e) => {
                    const ids = Array.from(
                      e.target.selectedOptions,
                      (option) => option.value
                    );

                    const selected = warehouses.filter((w) =>
                      ids.includes(w.id)
                    );

                    setSelectedWarehouses(selected);

                    const first = selected[0];

                    setFormData((prev) => ({
                      ...prev,
                      warehouseId: first?.id || "",
                      godownName: first?.name || "",
                      location: first?.address || "",
                      warehouseDetails: selected.map((w) => ({
                        id: w.id,
                        name: w.name,
                        address: w.address,
                      })),
                    }));
                  }}
                >
                  {warehouses.length === 0 ? (
                    <option disabled>
                      No warehouses found
                    </option>
                  ) : (
                    warehouses.map((w) => (
                      <option key={w.id} value={w.id}>
                        {w.name}
                      </option>
                    ))
                  )}
                </select>

                <small className="text-white">
                  Hold Ctrl and select multiple warehouses.
                </small>
              </div>

              {/* Selected Warehouse Summary */}
              {selectedWarehouses.length > 0 && (
                <div className="col-md-12">
                  <div className="bg-white rounded p-3">
                    <strong>Selected Warehouse(s):</strong>

                    <ul className="mb-0 mt-2">
                      {selectedWarehouses.map((w) => (
                        <li key={w.id}>
                          {w.name}
                          {w.address
                            ? ` — ${w.address}`
                            : ""}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

              {/* Location */}
              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="Location"
                  name="location"
                  value={formData.location}
                  readOnly
                />
              </div>

            </div>

            <hr className="my-4" />

            {/* Service Details */}
            <h6 className="fw-semibold mb-3 text-white">Service Details</h6>
            <table className="table table-bordered bg-white">
              <thead>
                <tr>
                  <th>Service</th>
                  <th>HSN Code</th>
                  <th>Billing</th>
                  <th>Qty (MT)</th>
                  <th>Rate</th>
                  <th>Amount</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {formData.items.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        className="form-control"
                        value={item.service}
                        onChange={(e) =>
                          handleItemChange(index, "service", e.target.value)
                        }
                      />
                    </td>

                    <td>
                      <select
                        className="form-control"
                        value={item.hsn_code || ""}
                        onChange={(e) => {
                          if (e.target.value === "ADD_NEW_HSN") {
                            setActiveHsnRow(index);
                            setShowAddHsn(true);
                            return;
                          }

                          handleItemChange(index, "hsn_code", e.target.value);
                        }}
                      >
                        <option value="">Select HSN</option>

                        {hsnList.map((hsn) => (
                          <option key={hsn.id} value={hsn.hsnCode}>
                            {hsn.hsnCode}
                          </option>
                        ))}

                        <option value="ADD_NEW_HSN">+ Add New HSN</option>
                      </select>
                    </td>

                    <td style={{ minWidth: "220px" }}>
                      {billType === "storage" ? (
                        <div>
                          <select
                            className="form-control mb-1"
                            value={item.billing_type || "MONTHLY"}
                            onChange={(e) =>
                              handleItemChange(
                                index,
                                "billing_type",
                                e.target.value
                              )
                            }
                          >
                            <option value="MONTHLY">Monthly</option>
                            <option value="DAILY">Daily</option>
                          </select>

                          {item.billing_type === "DAILY" && (
                            <>
                              <input
                                type="date"
                                className="form-control mb-1"
                                value={item.billing_start_date || ""}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "billing_start_date",
                                    e.target.value
                                  )
                                }
                              />

                              <input
                                type="date"
                                className="form-control mb-1"
                                value={item.billing_end_date || ""}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "billing_end_date",
                                    e.target.value
                                  )
                                }
                              />

                              <input
                                type="number"
                                className="form-control"
                                value={item.billing_days || ""}
                                readOnly
                                placeholder="Days"
                              />
                            </>
                          )}
                        </div>
                      ) : (
                        <span className="text-muted">—</span>
                      )}
                    </td>

                    <td>
                      <input
                        type="number"
                        className="form-control"
                        value={item.quantity}
                        onChange={(e) =>
                          handleItemChange(index, "quantity", e.target.value)
                        }
                      />
                    </td>

                    <td>
                      <input
                        type="number"
                        className="form-control"
                        value={item.rate}
                        onChange={(e) =>
                          handleItemChange(index, "rate", e.target.value)
                        }
                      />
                    </td>

                    <td>
                      <input
                        className="form-control bg-light"
                        value={item.amount}
                        readOnly
                      />
                    </td>

                    <td className="text-center">
                      {formData.items.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          onClick={() => removeRow(index)}
                        >
                          ✕
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <button
              type="button"
              className="btn btn-outline-light mt-2"
              onClick={addRow}
            >
              + Add Row
            </button>

            {showAddHsn && (
              <div className="mt-3 p-3 bg-light rounded">
                <div className="row align-items-center">
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter HSN Code"
                      value={newHsn}
                      onChange={(e) => setNewHsn(e.target.value)}
                    />
                  </div>

                  <div className="col-md-4 d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-success btn-sm"
                      onClick={async () => {
                        try {
                          if (!newHsn.trim()) {
                            toast.error("HSN cannot be empty");
                            return;
                          }

                          const token = sessionStorage.getItem("token");

                          const res = await axios.post(
                            "https://irc.zentelex.com/api/hsn/create",
                            { hsnCode: newHsn.trim() },
                            {
                              headers: {
                                Authorization: token ? `Bearer ${token}` : "",
                              },
                            }
                          );

                          const createdHsn = res.data.data; // ✅ FIXED

                          // 1️⃣ Update dropdown
                          setHsnList((prev) => [...prev, createdHsn]);

                          // 2️⃣ Auto select in correct row
                          if (activeHsnRow !== null) {
                            handleItemChange(
                              activeHsnRow,
                              "hsn_code",
                              createdHsn.hsnCode,
                            );
                          }

                          toast.success("HSN added successfully ✅");

                          setNewHsn("");
                          setShowAddHsn(false);
                          setActiveHsnRow(null);
                        } catch (err) {
                          toast.error(
                            err.response?.data?.message || "Error adding HSN",
                          );
                        }
                      }}
                    >
                      Add
                    </button>

                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => {
                        setShowAddHsn(false);
                        setNewHsn("");
                        setActiveHsnRow(null);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* GST Section */}
            {formData.invoiceType === "GST" && (
              <>
                <hr className="my-4" />
                <h6 className="fw-semibold mb-3 text-white">GST Details</h6>
                <div className="row g-3">
                  <div className="col-md-4">
                    <input
                      className="form-control"
                      placeholder="CGST %"
                      name="cgst"
                      value={formData.cgst}
                      onChange={(e) => {
                        handleChange(e);
                        const totals = recalculateTotals(
                          formData.items,
                          parseFloat(e.target.value) || 0,
                          parseFloat(formData.sgst) || 0,
                          formData.invoiceType,
                        );
                        setFormData((prev) => ({ ...prev, ...totals }));
                      }}
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      className="form-control"
                      placeholder="SGST %"
                      name="sgst"
                      value={formData.sgst}
                      onChange={(e) => {
                        handleChange(e);
                        const totals = recalculateTotals(
                          formData.items,
                          parseFloat(formData.cgst) || 0,
                          parseFloat(e.target.value) || 0,
                          formData.invoiceType,
                        );
                        setFormData((prev) => ({ ...prev, ...totals }));
                      }}
                    />
                  </div>
                </div>
              </>
            )}

            <hr className="my-4" />

            {/* Summary */}
            <h6 className="fw-semibold mb-3 text-white">Summary</h6>
            <div className="row g-3">
              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="Subtotal"
                  name="subtotal"
                  value={formData.subtotal}
                  readOnly
                />
              </div>
              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="Tax Amount"
                  name="taxAmount"
                  value={formData.taxAmount}
                  readOnly
                />
              </div>
              <div className="col-md-4">
                <input
                  className="form-control fw-bold"
                  placeholder="Grand Total"
                  name="grandTotal"
                  value={formData.grandTotal}
                  readOnly
                />

                {/* Amount in Words */}
                {formData.grandTotal && (
                  <small className="text-white d-block mt-1">
                    <strong>In Words:</strong>{" "}
                    {numberToWords(Number(formData.grandTotal))}
                  </small>
                )}
              </div>
            </div>

            <h6 className="fw-semibold mb-3 text-white">Note / Remarks</h6>
            <div className="row">
              <div className="col-md-12">
                <textarea
                  className="form-control"
                  rows="3"
                  name="note"
                  placeholder="Enter any remarks, payment terms, or special instructions..."
                  value={formData.note}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Submit */}
            <div className="text-end mt-4">
              <button type="submit" className="btn btn-primary px-4">
                Save Invoice
              </button>
            </div>
          </form>
        </div>
        <div className="mt-4">
          {billType === "labour" && (
            <LabourReportTable clientName={formData.clientName} />
          )}
          {billType === "storage" && (
            <ANNEXURE clientName={formData.clientName} />
          )}
        </div>
      </div>
      <ToastContainer />
    </Layout>
  );
}

